/*eslint-disable import/default*/
import 'babel-polyfill';
import React from 'react';
import {render} from 'react-dom';
import configureStore from './store/configureStore';
import {Provider} from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import routes from './routes';
import './styles/styles.css';
import './styles/print.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {retrieveAllForms} from './actions/formActions';
import {removeError} from './actions/errorActions';
const store = configureStore();
const history = syncHistoryWithStore(browserHistory,store);
store.dispatch(retrieveAllForms());


render(
  <Provider store={store}>
    <Router onUpdate={() => {
      window.scrollTo(0, 0);
      store.dispatch(removeError());
    }} history = {history} routes = {routes} />
  </Provider>,
  document.getElementById('app')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/